import posed from "react-pose"

export default posed.div({
  visible: {
    x: 0,
    beforeChildren: true,
    staggerChildren: 30
  },
  hidden: {
    x: "-100%",
    afterChildren: true
  }
})
